module.exports = __webpack_public_path__ + "img/cases-brand-avic-lazyload-138.16084301.jpg";